{
  "management": "Tuloskorttihallinta",
  "create_manage_scorecards": "Luo ja hallinnoi golfkenttien tuloskortteja",
  "create_new_scorecard": "Luo uusi tuloskortti",
  "edit_scorecard": "Muokkaa tuloskorttia",
  "search_scorecards": "Hae kentän nimellä tai kaupungilla...",
  "no_scorecards_found": "Tuloskortteja ei löytynyt",
  "tee_sets": "Lyöntipaikat",
  "course_info": "Kentän tiedot",
  "hole_config": "Reiät",
  "tee_set_config": "Lyöntipaikat",
  "review": "Yhteenveto",
  "course_information": "Kentän tiedot",
  "number_of_holes": "Reikien määrä",
  "use_current_location": "Käytä nykyistä sijaintia",
  "hole_configuration": "Reikien konfigurointi",
  "auto_assign": "Määritä automaattisesti",
  "total_par": "Par yhteensä",
  "par_distribution": "Par-jakauma",
  "par_3": "Par 3",
  "par_4": "Par 4",
  "par_5": "Par 5",
  "par_6": "Par 6",
  "tee_set_configuration": "Lyöntipaikkojen konfigurointi",
  "at_least_one_tee_set": "Vähintään yksi lyöntipaikka vaaditaan",
  "add_tee_set": "Lisää lyöntipaikka",
  "tee_name": "Lyöntipaikan nimi",
  "color": "Väri",
  "black": "Musta",
  "gold": "Kulta",
  "blue": "Sininen",
  "white": "Valkoinen",
  "yellow": "Keltainen",
  "red": "Punainen",
  "green": "Vihreä",
  "orange": "Oranssi",
  "purple": "Violetti",
  "championship": "Mestaruus",
  "tee_set": "Lyöntipaikka",
  "select_tee_set": "Valitse lyöntipaikka",
  "course_rating_male": "CR (miehet)",
  "slope_rating_male": "Slope (miehet)",
  "course_rating_female": "CR (naiset)",
  "slope_rating_female": "Slope (naiset)",
  "hole_distances": "Reikien etäisyydet (metriä)",
  "total_distance": "Kokonaisetäisyys",
  "meters": "metriä",
  "remove_tee_set": "Poista lyöntipaikka",
  "review_confirm": "Tarkista ja vahvista",
  "review_configuration": "Tarkista tuloskorttikonfiguraatiosi ennen tallentamista",
  "coordinates": "Koordinaatit",
  "hcp": "HCP",
  "confirm_delete_scorecard": "Oletko varma, että haluat poistaa tämän tuloskortin?",
  "scorecard_created_successfully": "Tuloskortti luotu onnistuneesti",
  "scorecard_updated_successfully": "Tuloskortti päivitetty onnistuneesti",
  "scorecard_deleted_successfully": "Tuloskortti poistettu onnistuneesti",
  "status_updated_successfully": "Tila päivitetty onnistuneesti",
  "failed_to_load_scorecards": "Tuloskorttien lataaminen epäonnistui",
  "failed_to_load_scorecard_details": "Tuloskortin tietojen lataaminen epäonnistui",
  "failed_to_save_scorecard": "Tuloskortin tallentaminen epäonnistui",
  "failed_to_delete_scorecard": "Tuloskortin poistaminen epäonnistui",
  "failed_to_update_status": "Tilan päivittäminen epäonnistui",
  "no_holes_configured": "Reikiä ei ole vielä konfiguroitu. Klikkaa 'Luo reiät' luodaksesi ne.",
  "initialize_holes": "Luo reiät",
  "scorecards_activated": "{{count}} tuloskorttia aktivoitu",
  "scorecards_deactivated": "{{count}} tuloskorttia poistettu käytöstä",
  "scorecards_deleted": "{{count}} tuloskorttia poistettu",
  "failed_to_activate": "Aktivointi epäonnistui",
  "failed_to_deactivate": "Käytöstä poistaminen epäonnistui",
  "failed_to_delete_scorecards": "Tuloskorttien poistaminen epäonnistui",
  "delete_scorecards": "Poista tuloskortit",
  "confirm_delete_scorecards": "Haluatko varmasti poistaa {{count}} tuloskorttia?",
  "owner_tenant": "Omistajaseura",
  "no_owner": "Ei omistajaa",
  "owned_by": "Omistaja: {{name}}",
  "visible_to_other_tenants": "Näkyvä muille seuroille",
  "shared_with": "Näkyy seuroille: {{names}}",
  "shared_tenants": "Näkyvyys muille seuroille",
  "shared_tenants_placeholder": "Valitse seurat...",
  "import_ebirdie": "Tuo eBirdiestä",
  "import_ebirdie_title": "Tuo kenttä eBirdiestä",
  "import_ebirdie_confirm": "Tuo",
  "import_ebirdie_failed": "Kentän tuonti eBirdiestä epäonnistui",
  "select_tenant": "Valitse seura",
  "ebirdie_course": "eBirdie-kenttä",
  "search_ebirdie_courses": "Hae kentän tai seuran nimellä...",
  "select_ebirdie_course": "Valitse kenttä",
  "no_shared_tenants_available": "Ei vaihtoehtoja"
}
